import { useEffect } from 'react'
import { Text } from '@mantine/core'
import type { TaskArgsComponentProps } from '../args-registry'

/** Args editor/viewer for warehouse.refresh: no args — it always rebuilds every view. */
export function WarehouseRefreshArgs({ value, onChange, readOnly }: TaskArgsComponentProps) {
  // Edit mode opened with no args: seed {} so the posted run carries explicit args.
  useEffect(() => {
    if (!readOnly && (value === undefined || value === null)) {
      onChange?.({})
    }
  }, [readOnly, value, onChange])

  return <Text size="sm">No arguments — rebuilds the warehouse views one at a time.</Text>
}
